module.exports = __webpack_public_path__ + "static/media/90.a94c7d0f.jpg";